import React from "react";
import {
  TextInput,
  getVal,
  setVal,
  Divider
} from "oolib";
import { SimpleTable } from "@/components/SimpleTable";
import { WidgetHeader } from "../WidgetBarChart/WIDGET_ELEM_ConfigForm";

export const WIDGET_ELEM_configForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
}) => {
  const dataKeys = {
    title: "props.title",
    tableData: "props.tableData",
  };

  const enforceComponentTypes = (tableData) => {
    if (!tableData?.data) return tableData;

    const blockConfig = [
      undefined, 
      { comp: 'NumberInput', props: { min: 0, placeholder: "Enter number..." } } // Value column - NumberInput
    ];

    return {
      ...tableData,
      data: tableData.data.map(row => ({
        ...row,
        cellData: row.cellData.map((cell, cellIdx) => ({
          ...cell,
          comp: blockConfig[cellIdx]?.comp || 'RichTextEditor',
          props: blockConfig[cellIdx]?.props || {}
        }))
      }))
    };
  };

  const updateConfig = (key, value) => {
    setConfig((prev) => {
      let modifiedConfig = JSON.parse(JSON.stringify(prev[underEditWidgetIdx]));
      modifiedConfig = setVal(modifiedConfig, key, value);
      
      const modifiedFullConfig = JSON.parse(JSON.stringify(prev));
      modifiedFullConfig[underEditWidgetIdx] = modifiedConfig;
      return modifiedFullConfig;
    });
  };

  const handleTableDataChange = (tableId, newTableData) => {

    const correctedTableData = enforceComponentTypes(newTableData);
    updateConfig(dataKeys.tableData, correctedTableData);
  };

  const currentTableData = getVal(thisWidgetConfig, dataKeys.tableData);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      
      <WidgetHeader title="Visualize Table" type="Widget" icon="ChartBarHorizontal" />

      <TextInput
        id={dataKeys.title}
        label="Custom widget title"
        placeholder="Enter title"
        value={getVal(thisWidgetConfig, dataKeys.title) || ""}
        onChange={(k, v) => updateConfig(dataKeys.title, v)}
      />

      <Divider style={{ margin: "0 -1.6rem" }}/>

      <div>
        <SimpleTable
          label="Data Input"
          sublabel="Enter key-value pairs for your chart. Keys will become bar labels, values determine bar heights."
          id={`table_${underEditWidgetIdx}`}
          config={{
            noOfRows: 3,
            noOfCols: 2,
            colHeaderData: ['Key', 'Value'],
            blockConfig: [
              undefined, 
              { 
                comp: 'NumberInput', 
                props: { 
                  min: 0,
                  placeholder: "Enter number..."
                } 
              } 
            ],
            disableAddRow: false,
            disableRowActionsMenu: false
          }}
          value={currentTableData}
          onChange={handleTableDataChange}
          defaultColWidth={150}
        />
      </div>
    </div>
  );
};